// extracted by mini-css-extract-plugin
export var content = "_dj-3";
export var list = "_dj-4";
export var settingsContent = "_dj-7";
export var settingsPanel = "_dj-8";
export var state = "_dj-6";
export var triggerBadge = "_dj-2";
export var triggerButton = "_dj-1";
export var triggerShell = "_dj-0";
export var unreadDot = "_dj-5";